"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconProhibited = function IconProhibited(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M9.858 38.142c-7.81-7.81-7.81-20.474 0-28.284s20.474-7.81 28.284 0 7.81 20.474 0 28.284-20.474 7.81-28.284 0m26.214-27.629c-7.106-6.372-18.04-6.143-24.87.688-6.832 6.832-7.061 17.765-.688 24.871zm1.414 1.415L11.928 37.488c7.106 6.372 18.04 6.143 24.87-.688 6.821-6.836 7.05-17.76.688-24.87",
    clipRule: "evenodd"
  })));
};

export { IconProhibited, IconProhibited as default };
